import classNames from 'classnames';
import styles from './FJMobileFooterModal.module.less';
import OkIcon from './../../../assets/svg/ok.svg?react';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import FJUtil from '../../../util/FJUtil';
import FJTextToImageDataConfig from '../../../config/dataConfig/FJTextToImageDataConfig';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJLocalStore from '../../../store/FJLocalStore';
import FJMobileTextToImageStyleList from '../FJMobileTextToImageStyleList/FJMobileTextToImageStyleList';
import FJConstant from '../../../constants/FJConstant';
import AIPromptOptimizeIcon from '../../../assets/svg/ai-prompt-optimize.svg?react';
import UseImageAsPromptIcon from '../../../assets/svg/use-image-as-prompt.svg?react';
import { useRef } from 'react';
import { UPLOAD_FILE_TYPE } from '../../../config/dataConfig/FJGenerateData';
const FJMobileFooterModal = props => {
    const {
        curModel,
        onChangeModel,
        curStyle,
        onChangeStyle,
        styleList,
        curRatio,
        onChangeRatio,
        generateNumber,
        onChangeGenerateNumber,
        mobileFooterModalData,
        useImageAsPrompt,
        aiOptimizing,
        onClose,
    } = props;
    const { type, hasMask, display } = mobileFooterModalData;
    const inputFileRef = useRef(null);
    const curRatioObj = FJTextToImageDataConfig.RATIO_LIST.find(item => item.name === curRatio);

    const _onMaskClick = e => {
        FJUtil.forbidEvent(e);
        onClose();
    };
    const _onUploadImg = e => {
        FJUtil.forbidEvent(e);
        const file = e.target.files[0];
        useImageAsPrompt(file);
        e.target.value = null;
    };

    const _onUploadImgClick = e => {
        FJUtil.forbidEvent(e);
        if (inputFileRef.current) {
            inputFileRef.current.click();
        }
    };
    useEffect(() => {
        if (!display || hasMask) return;
        FJUtil.addEvent(window, 'click', onClose);
        return () => {
            FJUtil.removeEvent(window, 'click', onClose);
        };
    }, [display, hasMask, onClose]);

    const _renderModelList = () => {
        return (
            <div className={styles.model_box}>
                {FJTextToImageDataConfig.MODELS.map((item, index) => {
                    return (
                        <FJHoverBoardGradation
                            key={index}
                            className={classNames(styles.models_item, item.value === curModel && styles.active)}
                            contentClassName={styles.models_item_box}
                            active={item.value === curModel}
                            onClick={() => {
                                onChangeModel(item);
                            }}
                        >
                            <item.icon />
                            <div className={styles.models_name}>{FJLocalStore._(item.name)}</div>
                        </FJHoverBoardGradation>
                    );
                })}
            </div>
        );
    };
    const _renderRatioList = () => {
        return (
            <div className={styles.select_box}>
                {FJTextToImageDataConfig.RATIO_LIST.map(item => {
                    return (
                        <FJHoverBoardGradation
                            className={classNames(styles.select_item, item.name === curRatioObj.name && styles.active)}
                            active={item.name === curRatioObj.name}
                            key={item.name}
                            onClick={() => onChangeRatio(item)}
                            contentClassName={styles.select_item_box}
                        >
                            <item.icon className={styles.select_item_icon} />
                            <div className={styles.select_item_name}>{item.name}</div>
                        </FJHoverBoardGradation>
                    );
                })}
            </div>
        );
    };
    const _renderGenerateNumber = () => {
        return (
            <div className={styles.select_box}>
                {FJTextToImageDataConfig.IMAGE_NUMBER_LIST.map(item => {
                    return (
                        <FJHoverBoardGradation
                            className={classNames(
                                styles.select_item,
                                styles.number_item,
                                item.value === generateNumber && styles.active,
                            )}
                            active={item.value == generateNumber}
                            key={item.text}
                            onClick={() => onChangeGenerateNumber(item.value)}
                            contentClassName={styles.select_item_box}
                        >
                            <div className={styles.select_item_name}>{item.text}</div>
                        </FJHoverBoardGradation>
                    );
                })}
            </div>
        );
    };
    const _renderStyleList = () => {
        return <FJMobileTextToImageStyleList list={styleList} onChangeStyle={onChangeStyle} curStyle={curStyle} />;
    };
    let title = '';
    switch (type) {
        case FJConstant.TEXT_TO_IMAGE_MODAL:
            title = FJLocalStore._('models');
            break;
        case FJConstant.TEXT_TO_IMAGE_RATIO:
            title = FJLocalStore._('aspect-ratio');
            break;
        case FJConstant.TEXT_TO_IMAGE_GENERATE_NUMBER:
            title = FJLocalStore._('quantity');
            break;
        case FJConstant.TEXT_TO_IMAGE_STYLE:
            title = FJLocalStore._('style');
            break;
        case FJConstant.TEXT_TO_IMAGE_AI_PROMPT:
            title = FJLocalStore._('ai-prompt');
            break;

        default:
            break;
    }
    const _renderAiPrompt = () => {
        return (
            <div className={styles.prompt_box}>
                {[
                    {
                        icon: AIPromptOptimizeIcon,
                        text: FJLocalStore._('improve-prompts'),
                        onClick: aiOptimizing,
                    },
                    {
                        icon: UseImageAsPromptIcon,
                        text: FJLocalStore._('use-image-as-prompt'),
                        onClick: _onUploadImgClick,
                    },
                ].map((item, index) => (
                    <div
                        key={index}
                        className={styles.prompt_item}
                        onClick={e => {
                            item.onClick(e);
                            onClose();
                        }}
                    >
                        <item.icon />
                        <div className={styles.prompt_item_text}>{item.text}</div>
                    </div>
                ))}

                <input
                    type='file'
                    ref={inputFileRef}
                    className={styles.file_input}
                    accept={UPLOAD_FILE_TYPE}
                    onChange={_onUploadImg}
                />
            </div>
        );
    };
    const _render = () => {
        switch (type) {
            case FJConstant.TEXT_TO_IMAGE_MODAL:
                return _renderModelList();
            case FJConstant.TEXT_TO_IMAGE_RATIO:
                return _renderRatioList();
            case FJConstant.TEXT_TO_IMAGE_GENERATE_NUMBER:
                return _renderGenerateNumber();
            case FJConstant.TEXT_TO_IMAGE_STYLE:
                return _renderStyleList();
            case FJConstant.TEXT_TO_IMAGE_AI_PROMPT:
                return _renderAiPrompt();
            default:
                break;
        }
    };
    const cn = classNames(styles.inner, display ? styles.show : styles.hide);
    return (
        <div
            className={classNames(styles.box, hasMask ? styles.mask : '', display ? styles.show : styles.hide)}
            onClick={_onMaskClick}
        >
            <div
                className={cn}
                onClick={e => {
                    e.stopPropagation();
                }}
            >
                {title && (
                    <div className={styles.header}>
                        <div className={styles.title}>{title}</div>
                        <OkIcon onClick={onClose} />
                    </div>
                )}
                {_render()}
            </div>
        </div>
    );
};
FJMobileFooterModal.propTypes = {
    mobileFooterModalData: PropTypes.object,
    onClose: PropTypes.func,
    generateNumber: PropTypes.number,
    onChangeGenerateNumber: PropTypes.func,
    curRatio: PropTypes.string,
    onChangeRatio: PropTypes.func,
    curModel: PropTypes.string,
    onChangeModel: PropTypes.func,
    curStyle: PropTypes.object,
    onChangeStyle: PropTypes.func,
    styleList: PropTypes.array,
    showFooterModal: PropTypes.func,
    aiOptimizing: PropTypes.func,
    useImageAsPrompt: PropTypes.func,
};
export default FJMobileFooterModal;
